import React from 'react';
import styled from 'styled-components';

const HowItWorksSection = styled.section`
  padding: 5rem 0;
  background: #f9fafb;
`;

const SectionTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 2.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1rem;
  color: #000;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const BlueText = styled.span`
  color: #253ec6;
`;

const SectionDescription = styled.p`
  text-align: center;
  font-size: 1.1rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto 4rem;
  line-height: 1.6;
`;

const StepsContainer = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 968px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const StepCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2.5rem 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-align: center;
  flex: 1;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 968px) {
    max-width: 100%;
  }
`;

const StepNumber = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #253ec6;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 auto 1rem;
`;

const StepLabel = styled.div`
  display: inline-block;
  background: #eff6ff;
  color: #253ec6;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 1rem;
  width: fit-content;
  align-self: center;
`;

const StepTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: #000;
`;

const StepDescription = styled.p`
  color: #666;
  line-height: 1.6;
  margin: 0;
  font-size: 0.95rem;
`;

const Arrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #666;
  margin-top: 2rem;
  align-self: center;

  @media (max-width: 968px) {
    display: none;
  }
`;

export default function HowItWorks() {
  return (
    <HowItWorksSection id="tasks">
      <div className="container">
        <SectionTitle>
          Clean home in 3 steps, <BlueText>zero effort required</BlueText>
        </SectionTitle>
        <SectionDescription>
          From booking to completion, we handle all the coordination so you can
          focus on what matters.
        </SectionDescription>

        <StepsContainer>
          <StepCard>
            <StepNumber>1</StepNumber>
            <StepLabel>Plans or Tasks</StepLabel>
            <StepTitle>Pick your service</StepTitle>
            <StepDescription>
              Choose between ongoing housekeeping plans or specific on-demand
              tasks that fit your needs
            </StepDescription>
          </StepCard>

          <Arrow>→</Arrow>

          <StepCard>
            <StepNumber>2</StepNumber>
            <StepLabel>Book in seconds</StepLabel>
            <StepTitle>Schedule instantly</StepTitle>
            <StepDescription>
              Select your preferred time window and any special instructions
              with our simple booking flow
            </StepDescription>
          </StepCard>

          <Arrow>→</Arrow>

          <StepCard>
            <StepNumber>3</StepNumber>
            <StepLabel>Done automatically</StepLabel>
            <StepTitle>We handle everything</StepTitle>
            <StepDescription>
              Our verified professionals coordinate building access and complete
              your cleaning to perfection
            </StepDescription>
          </StepCard>
        </StepsContainer>
      </div>
    </HowItWorksSection>
  );
}
